@if (filterTableConfig) {
  <!-- filter menu -->
  <form [formGroup]="filterTableForm">
    <button
      [matBadge]="activeFilterCount"
      matBadgeColor="primary"
      mat-icon-button
      [matMenuTriggerFor]="filterMenu"
      #menuTrigger="matMenuTrigger"
      (menuOpened)="onMenuOpened()"
    >
      <i-tabler name="filter" />
    </button>
    <mat-menu #filterMenu="matMenu" class="topbar-dd cardWithShadow p-3! pb-0!">
      <h2 class="text-lg font-medium px-3! m-0! mb-1!" (click)="$event.stopPropagation()" >{{ 'filter' | translate }}</h2>
      <div class="px-3">
        <mat-divider class="mb-0! opacity-70" />
      </div>
      <div class="p-3 flex flex-col gap-4.5!" (click)="onClickMenu($event)">
        @for (item of filterTableConfig.items; track $index) {
          <div>
            <mat-label class="font-medium block mb-1.5">{{ item.title ?? '' | translate }}</mat-label>
            @switch (item.controlType) {
              @case (controlType.SELECT) {
                <app-form-select
                  #formSelect
                  [formControlName]="item.key"
                  [fetchData]="item.fetchData"
                  [selectionConfig]="item?.selectionConfig ?? {}"
                  [onOpen]="getFormSelectOpenHandler(formSelect)"
                />
              }
              @case (controlType.AUTOCOMPLETE) {
                <app-autocomplete
                  #autocomplete
                  [formControlName]="item.key"
                  [placeholder]="item.placeholder ?? '' | translate"
                  [fetchData]="item.fetchData"
                  [selectionConfig]="item?.selectionConfig ?? {}"
                  [onOpen]="getAutocompleteOpenHandler(autocomplete)"
                />
              }
            }
          </div>
        }
        <mat-divider class="m-y-0 opacity-70" />
        <div class="d-flex justify-content-end gap-12">
          <button mat-button color="warn" class="dark:text-[var(--mat-color-primary)]!" (click)="handleClearFilter()">{{ 'clear' | translate }}</button>
          <button mat-flat-button color="primary" (click)="handleApplyFilter(menuTrigger)">{{ 'apply' | translate }}</button>
        </div>
      </div>
    </mat-menu>
  </form>
}
